import { render } from "./BankAccounts.vue?vue&type=template&id=c4958c48&scoped=true"
import script from "./BankAccounts.vue?vue&type=script&lang=js"
export * from "./BankAccounts.vue?vue&type=script&lang=js"

import "./BankAccounts.vue?vue&type=style&index=0&id=c4958c48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4958c48"]])

export default __exports__